/**************************************************
 * Nombre:       Tours_Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import Tarjeta_Tour from "../../Tarjetas/Tarjeta_Tour";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";


const Tours_Catalogo = ({data, seleccionado, setSeleccionado, cargarMas}) => {
    const {sCell} = useResponsive()
    const [toures, setToures] = useState([])

    useEffect(() => {


        setToures([])

        let arr = data.reduce((acumulador, objetoActual) => {
            if (!acumulador.find(o => o.id === objetoActual.id)) {
                acumulador.push(objetoActual);
            }
            return acumulador;
        }, []);

        setToures(arr)

    }, [data]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 32,
                                        fontWeight: 800
                                    }}>{seleccionado.nombre}</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        fontSize: 16,
                                        fontWeight: 300
                                    }}>
                                        {seleccionado.descripcion ? seleccionado.descripcion : 'Estas visualizando todos los tours'}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{
                                        fontSize: 15,
                                        fontWeight: 800
                                    }}>
                                        Tarifas Vigencia 01/01/25 hasta 31/12/25
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 4 : 0}}>
                            <Button
                                onClick={() => setSeleccionado({nombre: 'Todos'})}
                                variant={'outlined'} sx={{px: 6}}>Ver Todos</Button>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 10}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={6}
                            >



                                {toures.map((it, index) => {


                                    return (
                                        <Grid container size={{xs: 12, sm: 6, md: 4}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Tour item={it}/>
                                        </Grid>
                                    )
                                })}


                            </Grid>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 8}}>
                            <Button onClick={() => cargarMas()} variant={'outlined'}>Cargar Mas</Button>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tours_Catalogo

const items = [1, 2, 3, 4, 5, 6]